import { z } from 'zod';

export const emailSchema = z.string().email('Please enter a valid email address');

export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .regex(/[A-Z]/, 'Must contain at least one uppercase letter')
  .regex(/[0-9]/, 'Must contain at least one number');

export const urlSchema = z.string().url('Please enter a valid URL');

export const phoneSchema = z
  .string()
  .regex(/^\+?[\d\s\-()]{10,}$/, 'Please enter a valid phone number');

export function validateEmail(email: string): string | null {
  const result = emailSchema.safeParse(email);
  return result.success ? null : result.error.errors[0].message;
}

export function validatePhone(phone: string): string | null {
  if (!phone.trim()) return null; // optional by default; caller decides if required
  const result = phoneSchema.safeParse(phone);
  return result.success ? null : 'Please enter a valid phone number (e.g. (555) 123-4567)';
}

export function isValidUrl(url: string): boolean {
  return urlSchema.safeParse(url).success;
}

export const PHONE_PLACEHOLDER = '(000) 000-0000';

export function formatPhoneDisplay(value: string): string {
  const digits = value.replace(/\D/g, '');
  if (digits.length === 0) return '';
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return value; // return as-is if not 10/11 digits
}
